import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api/facade`;
export const AUTH = `${process.env.REACT_APP_BACKEND_URL}/api/auth`;
// Session lives in an httpOnly cookie set by the backend; only the non-secret user profile is kept in memory.
let currentUser = null;
export const getUser = () => currentUser;
export const setUser = (u) => { currentUser = u; };
localStorage.removeItem("fs_session");

export const fetchMe = () => axios.get(`${AUTH}/me`, { withCredentials: true }).then((r) => r.data).catch(() => null);
export const logout = () => axios.post(`${AUTH}/logout`, {}, { withCredentials: true }).catch(() => null);

export const api = axios.create({ baseURL: API, withCredentials: true });
api.interceptors.response.use((r) => r, (e) => {
  if (e?.response?.status === 401 && currentUser) { currentUser = null; window.location.reload(); }
  return Promise.reject(e);
});

export const errMsg = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d[0]?.msg) return d[0].msg.replace(/^Value error, /, "");
  return fallback;
};

export const downloadFile = async (url, filename) => {
  const res = await api.get(url, { responseType: "blob" });
  const href = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(href);
};

export const SYSTEM_LABELS = {
  curtain_wall: "Semi-Unitized Curtain Wall",
  skylight: "Skylight",
  canopy: "Canopy",
};
